import * as React from 'react';
import { getStyleStr } from './utils';
/**
 * Base size of the canvas, 1 for parallel layout and 2 for alternate layout
 * Only alternate layout is currently supported
 */
export const BaseSize = 2;
export const FontGap = 3;
// Prevent external hidden elements from adding accent styles
const EmphasizedStyles = {
    visibility: 'visible !important',
};
/**
 * 获取水印组件的钩子函数，用于在组件中添加或移除水印。
 *
 * @param markStyle 给水印元素设置的样式。
 * @returns 返回一个包含三个函数的数组：appendWatermark、removeWatermark和isWatermarkEle。
 * - appendWatermark 函数用于在指定容器中添加水印元素。参数为 base64Url（水印图片的 base64 编码字符串），markWidth（水印宽度）和 container（容器）。
 * - removeWatermark 函数用于从指定容器中删除水印元素。参数为 container（容器）。
 * - isWatermarkEle 函数用于判断某个节点是否为水印元素，并返回布尔值。参数为 ele（节点）。
 */
export default function useWatermark(markStyle) {
    const [watermarkMap] = React.useState(() => new Map());
    const appendWatermark = (base64Url, markWidth, container) => {
        if (container) {
            if (!watermarkMap.get(container)) {
                const newWatermarkEle = document.createElement('div');
                watermarkMap.set(container, newWatermarkEle);
            }
            const watermarkEle = watermarkMap.get(container);
            watermarkEle.setAttribute('style', getStyleStr(Object.assign(Object.assign(Object.assign({}, markStyle), { backgroundImage: `url('${base64Url}')`, backgroundSize: `${Math.floor(markWidth)}px`, 
                // @ts-ignore
                '-webkitPrintColorAdjust': 'exact', printColorAdjust: 'exact' }), EmphasizedStyles)));
            // Prevents using the browser `Hide Element` to hide watermarks
            watermarkEle.removeAttribute('class');
            if (watermarkEle.parentElement !== container) {
                container.append(watermarkEle);
            }
        }
        return watermarkMap.get(container);
    };
    const removeWatermark = (container) => {
        const watermarkEle = watermarkMap.get(container);
        if (watermarkEle && container) {
            container.removeChild(watermarkEle);
        }
        watermarkMap.delete(container);
    };
    const isWatermarkEle = (ele) => Array.from(watermarkMap.values()).includes(ele);
    return [appendWatermark, removeWatermark, isWatermarkEle];
}
